export class rmReweighmentreq{
    tabName:string
    farmerId?:number
    grnId?:number


    constructor(tabName:string, farmerId?:number ,grnId?:number){
        this.tabName =tabName
        this.farmerId =farmerId
        this.grnId = grnId
    }
}